<!-- <main id="content" role="main" class="w-full max-w-md mx-auto p-6">
  <div class="mt-7 bg-white rounded-xl shadow-lg border-2 border-purple-500">
    <div class="p-4 sm:p-7">
      <div class="text-center">
        <h1 class="block text-2xl font-bold">Forgot password?</h1>
        <p class="mt-2 text-sm text-gray-600">
          Remember your password?
          <a class="text-blue-600 hover:underline font-medium" routerLink="/login">
            Login here
          </a>
        </p>
      </div>

      <div class="mt-5">
        <form (ngSubmit)="onSubmit()">
          <div class="grid gap-y-4">
            <div>
              <label for="email" class="block text-sm font-bold ml-1 mb-2">Email address</label>
              <input
                type="email"
                id="email"
                name="email"
                [(ngModel)]="email"
                class="py-3 px-4 block w-full border-2 border-purple-200 rounded-md text-sm"
                required
              />
            </div>

            <button
              type="submit"
              class="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md font-semibold bg-purple-500 text-white hover:bg-purple-700"
            >
              Reset password
            </button>
          </div>
        </form>

        <p *ngIf="message" class="mt-4 text-green-600">{{ message }}</p>
        <p *ngIf="error" class="mt-4 text-red-600">{{ error.message }}</p>
      </div>
    </div>
  </div>

  <div >
  <h2>Reset Password</h2>
  <form (ngSubmit)="passwordSave()">
    <input 
      type="password" 
      placeholder="Enter new password" 
      [(ngModel)]="newPassword" 
      name="newPassword"
      required>
    <button type="submit">Set Password</button>
  </form>

  <p *ngIf="message" style="color:green">{{message}}</p>
  <p *ngIf="error" style="color:red">{{error.message}}</p>
</div>

</main> -->

<main id="content" role="main" class="w-full max-w-md mx-auto p-6">
  <div class="mt-7 bg-white rounded-xl shadow-lg border-2 border-purple-500">
    <div class="p-4 sm:p-7">
      <div class="text-center">
        <h1 class="block text-2xl font-bold">
          {{ token ? "Reset Password" : "Forgot password?" }}
        </h1>
        <p *ngIf="!token" class="mt-2 text-sm text-gray-600">
          Remember your password?
          <a
            class="text-blue-600 hover:underline font-medium"
            routerLink="/Signin/0"
          >
            Login here
          </a>
        </p>
      </div>

      <div class="mt-5">
        <!-- Forgot password form -->
        <form *ngIf="!token" (ngSubmit)="onSubmit()">
          <div class="grid gap-y-4">
            <div>
              <label for="email" class="block text-sm font-bold ml-1 mb-2"
                >Email address</label
              >
              <input
                type="email"
                id="email"
                name="email"
                [(ngModel)]="email"
                class="py-3 px-4 block w-full border-2 border-purple-200 rounded-md text-sm"
                required
              />
            </div>

            <button
              type="submit"
              class="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md font-semibold bg-purple-500 text-white hover:bg-purple-700"
            >
              Reset password
            </button>
          </div>
        </form>

        <!-- Reset password form -->
        <form *ngIf="token" (ngSubmit)="passwordSave()">
          <div class="grid gap-y-4">
            <div>
              <label for="newPassword" class="block text-sm font-bold ml-1 mb-2"
                >New Password</label
              >
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                [(ngModel)]="newPassword"
                class="py-3 px-4 block w-full border-2 border-purple-200 rounded-md text-sm"
                required
              />
            </div>

            <button
              type="submit"
              class="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md font-semibold bg-purple-500 text-white hover:bg-purple-700"
            >
              Set Password
            </button>
          </div>
        </form>

        <!-- Messages -->
        <p *ngIf="message" class="mt-4 text-green-600">{{ message }}</p>
        <p *ngIf="error" class="mt-4 text-red-600">{{ error }}</p>
      </div>
    </div>
  </div>
</main>
